import { MagazineData } from '@modules/content-api/adapter/magazine.adapter';
import { createSectionByType, Section } from '@modules/section/models/section.model';

export class Magazine implements MagazineData {
  public readonly id: string;
  public readonly title: string;
  public readonly description: string | null;
  public readonly currentSlug: string;
  public readonly slugs: { lang: string; value: string }[];
  public readonly sections: Section[];

  constructor(data: MagazineData) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description || '';
    this.currentSlug = data.currentSlug;
    this.slugs = data.slugs;
    this.sections = data.sections.map((section) => createSectionByType(section)).filter(Boolean) as Section[];
  }

  // Class-based functions go here
}
